<div style="text-align: center">
  <fa-icon [icon]="icon" size="4x"></fa-icon>
  <div style="padding-top: 0.2rem; font-weight: 300; font-size: 1.2rem;">{{text}}</div>
</div>
